import React from 'react'

const QuillTextDisplay = (props) => {
const quillContent = props?.text
  return (
    <span className="quill-content-container">
    <span 
    className="quill-content" 
    dangerouslySetInnerHTML={{ __html: quillContent }} />
  </span>
  )
}

export default QuillTextDisplay
